module.exports = __webpack_public_path__ + "img/no_zone_selected.8c361f64.svg";